"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPriceV2 = void 0;
const react_1 = __importStar(require("react"));
const view_1 = require("../html-widget/view");
const list_price_1 = require("../list-price");
const page_wrapper_1 = require("../page-wrapper");
const see_price_in_cart_1 = require("../see-price-in-cart");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const MediumSizedPrice = (props) => {
    const { currencySymbol, wholeValue, fractionalValue, decimalSeparator = '.', currencySymbolPosition = 'left' } = props;
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    const price = `${wholeValue}${decimalSeparator}${fractionalValue}`;
    return currencySymbolPosition === 'right' ? (react_1.default.createElement(styles_1.PriceValueContainer, Object.assign({ "data-cy": 'price-value-container' }, props, { font: props.size }),
        react_1.default.createElement(themed_text_1.ThemedSpan, { "data-cy": 'price-value', font: props.size }, price),
        react_1.default.createElement(styles_1.RightCurrency, Object.assign({ "data-cy": 'currency', deviceType: deviceType }, props), currencySymbol))) : (react_1.default.createElement(styles_1.PriceValueContainer, Object.assign({ "data-cy": 'price-value-container' }, props, { font: props.size }),
        react_1.default.createElement(styles_1.LeftCurrency, Object.assign({ "data-cy": 'currency', deviceType: deviceType }, props), currencySymbol),
        react_1.default.createElement(themed_text_1.ThemedSpan, Object.assign({ "data-cy": 'price-value' }, props), price)));
};
const PriceAsPlainString = (props) => {
    const { currencySymbol, wholeValue, fractionalValue, decimalSeparator = '.', currencySymbolPosition = 'left' } = props;
    const price = currencySymbolPosition === 'right'
        ? `${wholeValue}${decimalSeparator}${fractionalValue}${currencySymbol}`
        : `${currencySymbol}${wholeValue}${decimalSeparator}${fractionalValue}`;
    return (react_1.default.createElement(styles_1.PriceValueContainer, Object.assign({ "data-cy": 'price-currency-value' }, props, { font: props.size }), price));
};
const TopAnchoredFractionalPrice = (props) => {
    const { currencySymbol, wholeValue, fractionalValue, decimalSeparator = '.', currencySymbolPosition = 'left' } = props;
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    const priceAriaLabel = currencySymbolPosition === 'right'
        ? `${wholeValue}${decimalSeparator}${fractionalValue}${currencySymbol}`
        : `${currencySymbol}${wholeValue}${decimalSeparator}${fractionalValue}`;
    return (react_1.default.createElement(styles_1.SubsScriptPriceContainer, null,
        react_1.default.createElement(styles_1.OffScreenPrice, null, priceAriaLabel),
        currencySymbolPosition === 'right' ? (react_1.default.createElement(styles_1.PriceValueContainer, Object.assign({ "aria-hidden": 'true' }, props),
            react_1.default.createElement(themed_text_1.ThemedSpan, { "data-cy": 'price-whole-value', font: props.size }, wholeValue),
            react_1.default.createElement(styles_1.FractionalValue, Object.assign({ deviceType: deviceType, "data-cy": 'price-fractional-value' }, props), fractionalValue),
            react_1.default.createElement(styles_1.RightCurrency, Object.assign({ deviceType: deviceType, "data-cy": 'currency' }, props), currencySymbol))) : (react_1.default.createElement(styles_1.PriceValueContainer, Object.assign({ "aria-hidden": 'true' }, props),
            react_1.default.createElement(styles_1.LeftCurrency, Object.assign({ deviceType: deviceType, "data-cy": 'currency' }, props), currencySymbol),
            react_1.default.createElement(themed_text_1.ThemedSpan, { "data-cy": 'price-whole-value', font: props.size }, wholeValue),
            react_1.default.createElement(styles_1.FractionalValue, Object.assign({ deviceType: deviceType, "data-cy": 'price-fractional-value' }, props), fractionalValue)))));
};
const Price = (props) => {
    switch (props.size) {
        case 'mini':
        case 'small':
        case 'base':
            return react_1.default.createElement(PriceAsPlainString, Object.assign({}, props));
        case 'medium':
            return react_1.default.createElement(MediumSizedPrice, Object.assign({}, props));
        case 'basePlus':
        case 'mediumPlus':
        case 'extraLarge':
        case 'doubleLarge':
        case 'large':
            return react_1.default.createElement(TopAnchoredFractionalPrice, Object.assign({}, props));
        default:
            return react_1.default.createElement(PriceAsPlainString, Object.assign({}, props));
    }
};
const ProductPriceV2 = (props) => {
    const { currencySymbol, currencySymbolPosition = 'left' } = props;
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    return props.isPriceMAPSuppressed ? (react_1.default.createElement(see_price_in_cart_1.SeePriceInCart, Object.assign({}, props.seePriceInCartProps, { withPopover: props.seePriceInCartWithPopover }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.PriceContainer, null,
            react_1.default.createElement(styles_1.PriceSpan, Object.assign({}, props),
                props.percentSavings && (react_1.default.createElement(styles_1.PercentSavings, Object.assign({ deviceType: deviceType, "data-cy": 'price-savings' }, props, { font: props.size }), props.percentSavings)),
                react_1.default.createElement(Price, Object.assign({ "data-cy": 'price' }, props)),
                props.subscriptionTermString && (react_1.default.createElement(styles_1.SubscriptionTerm, Object.assign({ deviceType: deviceType }, props), props.subscriptionTermString)),
                props.showPriceMessage && props.priceMessage && (react_1.default.createElement(styles_1.PriceMessage, Object.assign({ deviceType: deviceType }, props), props.priceMessage)))),
        props.priceDetails && (react_1.default.createElement(styles_1.PriceDetails, Object.assign({ deviceType: deviceType, "data-cy": 'price-details' }, props, { font: props.size }), (0, view_1.SafeHtmlParse)(props.priceDetails))),
        props.showListPrice && (react_1.default.createElement(list_price_1.ListPrice, Object.assign({ topSpacing: !!props.priceDetails, typographySize: 'small', currencySymbol: currencySymbol, currencySymbolPosition: currencySymbolPosition, subscriptionTermString: props.subscriptionTermString }, props.listPriceProps)))));
};
exports.ProductPriceV2 = ProductPriceV2;
